import apiRequest from './apiClient';

const inlineParams = (userId, hash) =>
  userId && hash ? `?userId=${userId}&hash=${hash}` : '';

/**
 * Получить советуемые роли для текущего пользователя
 * GET /api/role-suggestions
 */
export const getRoleSuggestions = (userId, hash) =>
  apiRequest(`/api/role-suggestions${inlineParams(userId, hash)}`);

/**
 * Удалить советуемую роль из списка suggestions
 * POST /api/role-suggestions/role-suggestions/{roleSuggestionId}/remove
 */
export const removeRoleSuggestion = (roleSuggestionId, userId, hash) =>
  apiRequest(`/api/role-suggestions/role-suggestions/${roleSuggestionId}/remove${inlineParams(userId, hash)}`, {
    method: 'POST',
  });

/**
 * Понизить AUTO_ADD до SUGGEST (вызывается в createMode при удалении роли из списка)
 * POST /api/role-suggestions/role-suggestions/{roleSuggestionId}/to-suggest-status
 */
export const toSuggestStatus = (roleSuggestionId, userId, hash) =>
  apiRequest(`/api/role-suggestions/role-suggestions/${roleSuggestionId}/to-suggest-status${inlineParams(userId, hash)}`, {
    method: 'POST',
  });